/* tslint:disable */
/* eslint-disable */
/**
 * Leads API
 * API for managing leads (potential customers from external sources)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MaterialiserLeadErrorDto } from './MaterialiserLeadErrorDto';
import {
    MaterialiserLeadErrorDtoFromJSON,
    MaterialiserLeadErrorDtoFromJSONTyped,
    MaterialiserLeadErrorDtoToJSON,
    MaterialiserLeadErrorDtoToJSONTyped,
} from './MaterialiserLeadErrorDto';

/**
 * Résultat de la conversion, commun aux 3 routes de matérialisation (CBNO, GLI, emprunteur). Les erreurs MÉTIER arrivent en HTTP 200 avec success=false (lead déjà converti, affecté à un autre courtier, courtier hors plateforme, branche ne correspondant pas à la route) — afficher errors[].message.
 * 
 * @export
 * @interface MaterialiserLeadCbnoResponse
 */
export interface MaterialiserLeadCbnoResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MaterialiserLeadCbnoResponse
     */
    success: boolean;
    /**
     * Erreurs métier (success=false)
     * @type {Array<MaterialiserLeadErrorDto>}
     * @memberof MaterialiserLeadCbnoResponse
     */
    errors?: Array<MaterialiserLeadErrorDto>;
    /**
     * Simulation créée. Emprunteur : risque de l'assuré de rang 1 (celui tracé sur le lead) — la redirection se fait sur projectId, pas sur ce champ.
     * 
     * @type {string}
     * @memberof MaterialiserLeadCbnoResponse
     */
    riskId?: string | null;
    /**
     * EMPRUNTEUR uniquement — dossier (projet d'emprunt) créé. C'est LUI qui sert à la redirection : le parcours emprunteur et le comparateur travaillent au niveau projet.
     * 
     * @type {string}
     * @memberof MaterialiserLeadCbnoResponse
     */
    projectId?: string | null;
    /**
     * EMPRUNTEUR uniquement — un risque par assuré (1 ou 2 entrées), dans l'ordre des assurés du lead. La 1re entrée correspond à riskId / fileReference.
     * 
     * @type {Array<string>}
     * @memberof MaterialiserLeadCbnoResponse
     */
    riskIds?: Array<string>;
    /**
     * N° de dossier créé. Emprunteur : celui de l'assuré de rang 1.
     * 
     * @type {string}
     * @memberof MaterialiserLeadCbnoResponse
     */
    fileReference?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MaterialiserLeadCbnoResponse
     */
    personId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MaterialiserLeadCbnoResponse
     */
    realEstateId?: string | null;
    /**
     * Libellés déjà rédigés pour l'utilisateur, à afficher tels quels en checklist avant devis (ne rien parser, ne rien traduire). Longueur variable et LISTE POSSIBLEMENT VIDE — cas nominal en emprunteur depuis que le contrat partenaire impose l'adresse complète de chaque assuré et la date de début du projet : ne pas afficher le panneau si vide.
     * 
     * @type {Array<string>}
     * @memberof MaterialiserLeadCbnoResponse
     */
    fieldsToComplete?: Array<string>;
}

/**
 * Check if a given object implements the MaterialiserLeadCbnoResponse interface.
 */
export function instanceOfMaterialiserLeadCbnoResponse(value: object): value is MaterialiserLeadCbnoResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function MaterialiserLeadCbnoResponseFromJSON(json: any): MaterialiserLeadCbnoResponse {
    return MaterialiserLeadCbnoResponseFromJSONTyped(json, false);
}

export function MaterialiserLeadCbnoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaterialiserLeadCbnoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(MaterialiserLeadErrorDtoFromJSON)),
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'riskIds': json['riskIds'] == null ? undefined : json['riskIds'],
        'fileReference': json['fileReference'] == null ? undefined : json['fileReference'],
        'personId': json['personId'] == null ? undefined : json['personId'],
        'realEstateId': json['realEstateId'] == null ? undefined : json['realEstateId'],
        'fieldsToComplete': json['fieldsToComplete'] == null ? undefined : json['fieldsToComplete'],
    };
}

export function MaterialiserLeadCbnoResponseToJSON(json: any): MaterialiserLeadCbnoResponse {
    return MaterialiserLeadCbnoResponseToJSONTyped(json, false);
}

export function MaterialiserLeadCbnoResponseToJSONTyped(value?: MaterialiserLeadCbnoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(MaterialiserLeadErrorDtoToJSON)),
        'riskId': value['riskId'],
        'projectId': value['projectId'],
        'riskIds': value['riskIds'],
        'fileReference': value['fileReference'],
        'personId': value['personId'],
        'realEstateId': value['realEstateId'],
        'fieldsToComplete': value['fieldsToComplete'],
    };
}

